'use client';

import { useEffect, useState, type RefObject } from 'react';

import { DEVICE_WIDTHS } from '@/types/feedback';

import {
  FRAME_GAP_NATIVE,
  HORIZONTAL_PADDING,
  PREVIEW_DEVICES,
} from './canvasConstants';

export function useCanvasScale(
  containerRef: RefObject<HTMLDivElement | null>,
): number {
  const [scale, setScale] = useState(0.5);

  useEffect(() => {
    const container = containerRef.current;
    if (!container) return;

    function compute() {
      const totalNativeWidth =
        PREVIEW_DEVICES.reduce((sum, d) => sum + DEVICE_WIDTHS[d], 0) +
        FRAME_GAP_NATIVE * (PREVIEW_DEVICES.length - 1);
      const available = container!.clientWidth - HORIZONTAL_PADDING;
      setScale(Math.max(0.1, Math.min(1, available / totalNativeWidth)));
    }

    compute();
    const ro = new ResizeObserver(compute);
    ro.observe(container);
    return () => ro.disconnect();
  }, [containerRef]);

  return scale;
}
